import React from 'react'
import { Link } from 'react-router-dom'
import { Image } from '..'
import {
  Slide,
  WrapperBtn
} from './styles'

const CarouselCard = ({
  to,
  imgSrc,
  onClick,
  isHoverEffect=true,
  isRounded=true
}) => {

  if (onClick) return (
    <WrapperBtn onClick={onClick}>
      <Slide
        $isHoverEffect={isHoverEffect}
        $isRounded={isRounded}
      >
        <Image src={imgSrc} alt='' />
      </Slide>
    </WrapperBtn>
  )

  return (
    <Link to={to}>
      <Slide
        $isHoverEffect={isHoverEffect}
        $isRounded={isRounded}
      >
        <Image src={imgSrc} alt='' />
      </Slide>
    </Link>
  )
}

export default CarouselCard